module.exports = shared.CurrencySymbolMap;